import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export function initRouter(routes, mode = 'abstract', base = getRouterBase()) {
  const router = new VueRouter({
    mode,
    base,
    routes
  })
  if (mode === 'abstract') {
    router.replace('/')
  }
  router.afterEach((to, from) => {
    setTimeout(() => {
      // window.scrollTo(0, 0)
    }, 200) // .router-view-change-leave-active transition time
  })

  const abortCallbacks = []
  const processAbortCallbacks = () => {
    abortCallbacks.forEach((callback) => {
      callback()
    })
  }
  const getExtendedFunction = (originalFn) =>
    function(...args) {
      // If more than 1 argument - method called with callbacks
      if (args.length > 1) {
        const [location, onComplete, onAbort] = args

        return originalFn.call(this, location, onComplete, () => {
          processAbortCallbacks()
          onAbort && onAbort()
        })
      }
      // Needed to prevent error: Avoided redundant navigation to current location
      if (args && args[0]) {
        // Otherwise it will return promise
        return originalFn.apply(this, args)?.catch((error) => {
          processAbortCallbacks()
          return error
          // return Promise.reject(error)
        })
      }
    }
  const routerPush = VueRouter.prototype.push
  const routerReplace = VueRouter.prototype.replace

  VueRouter.prototype.push = getExtendedFunction(routerPush)
  VueRouter.prototype.replace = getExtendedFunction(routerReplace)
  VueRouter.prototype.onAbort = (callback) => {
    abortCallbacks.push(callback)
  }

  return router
}

export function getRouterBase() {
  return (
    global.__CUSTOM_ELEMENT_ROUTER_BASE__ ||
    (global.location && global.location.pathname) ||
    '/'
  )
}
